
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/[...categorySlugs]",
      function () {
        return require("private-next-pages/c/[...categorySlugs].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/[...categorySlugs]"])
      });
    }
  